import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export class AuthUtility {
  static isUnauthorizedError(error: unknown): boolean {
    const isHttpError = error instanceof HttpErrorResponse;

    return isHttpError
      && error.status === HttpStatusCode.Unauthorized;
  }
}
